const COLORS = { connected: "#0AE2FF", pending: "rgba(234,236,239,0.45)", compromised: "#FF5B5B" };

export function OrbitalMark({ className = "w-8 h-8", status = "connected", spinning = false }) {
  const c = COLORS[status];
  return (
    <svg viewBox="0 0 48 48" className={className} fill="none" aria-hidden="true">
      <ellipse cx="24" cy="24" rx="20" ry="9" transform="rotate(-28 24 24)" stroke={c} strokeWidth="1.5" strokeDasharray={status === "pending" ? "3 3" : undefined} opacity="0.9" />
      <g className={spinning || status === "connected" ? "animate-orbit" : ""}>
        <circle cx="41" cy="14.5" r="2.6" fill={c} />
      </g>
      <rect x="18.5" y="22" width="11" height="9" rx="1.8" stroke={c} strokeWidth="1.5" />
      {status === "compromised" ? (
        <path d="M21 22v-2.6a3 3 0 0 1 5.6-1.5" stroke={c} strokeWidth="1.5" strokeLinecap="round" />
      ) : (
        <path d="M21 22v-2.6a3 3 0 0 1 6 0V22" stroke={c} strokeWidth="1.5" strokeLinecap="round" />
      )}
    </svg>
  );
}

const LABELS = { connected: "Orbital Lock engaged", pending: "Awaiting handshake", compromised: "Lock compromised" };

export function OrbitalLock({ status, onClick, testId = "orbital-lock-btn" }) {
  const tone = status === "connected" ? "text-stellar border-stellar/30 shadow-stellar-glow" : status === "compromised" ? "text-flare border-flare/40 shadow-flare-glow" : "text-ash/60 border-rim";
  return (
    <button onClick={onClick} data-testid={testId} data-state={status} className={`flex items-center gap-2 pl-1.5 pr-3 py-1 rounded-secure border bg-void/60 transition-colors hover:bg-nebula ${tone}`}>
      <OrbitalMark className="w-6 h-6" status={status} />
      <span className="font-branding text-[11px] uppercase tracking-[0.14em] hidden sm:inline">{LABELS[status]}</span>
    </button>
  );
}
